// extracted by mini-css-extract-plugin
export default {"bottomIconDiv":"ToggleVideoButton_bottomIconDiv__zSL7I","bottomIcon":"ToggleVideoButton_bottomIcon__3MvNI","bottomText":"ToggleVideoButton_bottomText__kmh-Z"};